export const rcpValues = ["rcp26", "rcp45", "rcp60", "rcp85"] as const;

export type Rcp = (typeof rcpValues)[number];

export const DEFAULT_RCP: Rcp = "rcp85";

export const RCP_COLORS: Record<Rcp, string> = {
  rcp26: "#ffb300",
  rcp45: "#ff7d00",
  rcp60: "#e32685",
  rcp85: "#9d02d7",
};

export const SCENARIO_DETAILS = {
  rcp: {
    title: "Representative Concentration Pathway (RCP)",
    description:
      "Representative Concentration Pathway; An emission scenario as defined by the Intergovernmental Panel on Climate Change (IPCC).",
  },
  ssp: {
    title: "Shared Socioeconomic Pathway",
    description:
      "An emission scenario that integrates socioeconomic narratives, as defined in the IPCC Sixth Assessment Report on climate change (2021)",
  },
};
